var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.375,
    height: 40.707,
    viewBox: "0 0 47.375 40.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#09c}.cls-3{fill:#272727}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12368",
    "data-name": "Grupo 12368",
    transform: "translate(-251.142 -110.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11035",
    "data-name": "Grupo 11035",
    transform: "translate(273.196 121.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25659",
    d: "M267.28 136.967v-17.762l13.815 8.881z",
    className: "cls-1",
    "data-name": "Trazado 25659",
    transform: "translate(-267.28 -119.205)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(251.142 110.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_71",
    "data-name": "Path 71",
    transform: "translate(.705 .888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25660",
    d: "M280.3 111.1h-7.278l-6.039 1.414-6.041 2.982-3.579 2.268-2.858 3.319-2.118 4.237-.843 4.348.442 4.241 1.225 3.565 1.756 2.91 2.771 3.176 3.2 2.832 4.979 2.076 4.646 1.359 6.135.206-1.083-1.1-4.026-1.422-3.717-2.085-3.872-3.367-3.062-4.325-1.443-5.5v-5.305l3.039-6.233 3.646-3.987 4.385-2.782 5.047-1.778z",
    className: "cls-1",
    "data-name": "Trazado 25660",
    transform: "translate(-251.539 -111.095)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4",
    transform: "translate(7.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11036",
    "data-name": "Grupo 11036",
    transform: "translate(.113 .113)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_221",
    cx: 19.76,
    cy: 20.24,
    fill: "none",
    "data-name": "Elipse 221",
    rx: 19.76,
    ry: 20.24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11037",
    "data-name": "Grupo 11037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25661",
    d: "M275.312 151.3a20.359 20.359 0 1 1 19.873-20.353 20.139 20.139 0 0 1-19.873 20.353zm0-39.255a18.907 18.907 0 1 0 18.456 18.9 18.7 18.7 0 0 0-18.456-18.898z",
    className: "cls-3",
    "data-name": "Trazado 25661",
    transform: "translate(-255.44 -110.595)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined_Shape-3",
    "data-name": "Combined Shape-3",
    transform: "translate(0 .114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25662",
    d: "M275.918 151.139c-13.683 0-24.776-9.061-24.776-20.239a18.567 18.567 0 0 1 7.257-14.314 27.665 27.665 0 0 1 17.519-5.927v1.265c-12.828 0-23.228 8.5-23.227 18.976a17.41 17.41 0 0 0 6.8 13.417 25.923 25.923 0 0 0 16.424 5.557z",
    className: "cls-3",
    "data-name": "Trazado 25662",
    transform: "translate(-251.142 -110.659)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-8",
    transform: "translate(19.771 .113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4373",
    d: "M0 0H7.742V1.548H0z",
    className: "cls-3",
    "data-name": "Rect\\xE1ngulo 4373"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Copy_4",
    "data-name": "Rectangle Copy 4",
    transform: "translate(19.771 39.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4374",
    d: "M0 0H7.742V1.548H0z",
    className: "cls-3",
    "data-name": "Rect\\xE1ngulo 4374"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.197b83b61c56fbc7349cd1d3ee815bfe.svg";
export { ForwardRef as ReactComponent };